import React, { ReactElement, useEffect, useState } from "react";
// import { SquireButton } from "../StyledComp/StyledComp";
// import { screenConfig } from "../../config/screenConfig";
// import { useDispatch } from "react-redux";
// import { screenChange } from "../../store/screenSlice";
import "../../Styles/MenuBarStyles.css";

interface IProps {
  id: string;
  image: ReactElement;
  alternate: string;
  isActive: boolean;
  callBack: (id: string) => void;
}

const MenuBarItem: React.FC<IProps> = (props) => {
  // const dispatch = useDispatch();

  const [activeButtonStyle, setActiveButtonStyle] = useState(
    "menubar-item-wrapper"
  );

  useEffect(() => {
    setActiveStatus();
  });

  const setActiveStatus = () => {
    if (props.isActive) {
      setActiveButtonStyle("menubar-item-wrapper-active");
      console.log("ActiveMenuId:", props.id);
    } else {
      setActiveButtonStyle("menubar-item-wrapper");
    }
  };

  return (
    <div className={activeButtonStyle} onClick={() => props.callBack(props.id)}>
      <div>{props.image}</div>
      <div style={{ textAlign: "center" }}>{props.id}</div>
    </div>
  );
};

export default MenuBarItem;
